module.exports = __webpack_public_path__ + "img/MassHills.fadc4eb4.png";